import React from "react";
import T from "prop-types";
import Portal from "MODULES/shared/containers/Portal";

function ImagePortal({ name, open, url, setOpen }) {
  if (!open || !url) return null;

  return (
    <Portal>
      <div className="portal-overlay">
        <button className="portal-overlay" onClick={() => setOpen(!open)} />
      </div>
      <img
        alt={name}
        src={url}
        width="33%"
        style={{
          boxShadow: "0 4px 4px rgba(0, 0, 0, 0.7)",
          zIndex: 2041,
          marginLeft: "33%",
          position: "fixed",
          top: "10%"
        }}
      />
    </Portal>
  );
}

ImagePortal.propTypes = {
  name: T.string,
  open: T.bool.isRequired,
  url: T.string.isRequired,
  setOpen: T.func.isRequired
};

export default ImagePortal;



// WEBPACK FOOTER //
// ./app/modules/shared/components/ImagePortal/ImagePortal.jsx